import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { unlockedTutorialItemIdentifierStruct } from "./unlockedTutorialsIdentifierStruct";

const unlockedTutorialResourceStruct = createResourceStruct({
  identifier: unlockedTutorialItemIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
  }),
  meta: sup.object({
    completedAt: sup.nullable(sup.string()),
    testPassed: sup.boolean(),
    minimumLevelOrder: sup.integer(),
    testQuestionsNumber: sup.integer(),
    tutorialStepsCompleted: sup.integer(),
    tutorialStepsNumber: sup.integer(),
  }),
});

export const unlockedTutorialsResourceStruct = sup.array(
  unlockedTutorialResourceStruct
);
